import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_2 = { class: "fixed inset-0 z-10 overflow-y-auto" }
const _hoisted_3 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_4 = { class: "flex flex-col bg-white gap-3" }
const _hoisted_5 = { class: "flex flex-col items-center px-6 py-8 relative" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 6L6 18M6 6L18 18",
    stroke: "#98A2B3",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_20365_3025)" }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M57.1433 2.28516H6.85756C5.64514 2.28516 4.48238 2.76679 3.62507 3.6241C2.76776 4.48141 2.28613 5.64417 2.28613 6.85658V45.7137C2.28613 46.9261 2.76776 48.0889 3.62507 48.9462C4.48238 49.8035 5.64514 50.2852 6.85756 50.2852H16.0004V61.7137L30.2633 50.2852H57.1433C58.3557 50.2852 59.5185 49.8035 60.3758 48.9462C61.2331 48.0889 61.7147 46.9261 61.7147 45.7137V6.85658C61.7147 5.64417 61.2331 4.48141 60.3758 3.6241C59.5185 2.76679 58.3557 2.28516 57.1433 2.28516Z",
        stroke: "#4B5563",
        "stroke-width": "4.57143",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M25.1426 20.572C25.1426 19.2158 25.5447 17.89 26.2982 16.7624C27.0517 15.6347 28.1226 14.7558 29.3756 14.2368C30.6286 13.7178 32.0073 13.582 33.3375 13.8466C34.6676 14.1112 35.8895 14.7643 36.8485 15.7233C37.8074 16.6822 38.4605 17.9041 38.7251 19.2342C38.9897 20.5644 38.8539 21.9431 38.3349 23.1961C37.8159 24.4491 36.937 25.52 35.8093 26.2735C34.6817 27.027 33.3559 27.4291 31.9997 27.4291V29.7148",
        stroke: "#4B5563",
        "stroke-width": "4.57143",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        d: "M31.9999 36.5723C31.3218 36.5723 30.6589 36.7733 30.0951 37.1501C29.5312 37.5268 29.0918 38.0623 28.8323 38.6888C28.5728 39.3153 28.5049 40.0046 28.6372 40.6697C28.7695 41.3348 29.096 41.9457 29.5755 42.4252C30.055 42.9047 30.6659 43.2312 31.331 43.3635C31.9961 43.4958 32.6854 43.4279 33.3119 43.1684C33.9384 42.9089 34.4739 42.4695 34.8506 41.9056C35.2274 41.3418 35.4284 40.6789 35.4284 40.0008C35.4166 39.0952 35.0516 38.23 34.4111 37.5896C33.7707 36.9491 32.9055 36.5841 31.9999 36.5723Z",
        fill: "#4B5563"
      })
    ]),
    /*#__PURE__*/_createElementVNode("defs", null, [
      /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_20365_3025" }, [
        /*#__PURE__*/_createElementVNode("rect", {
          width: "64",
          height: "64",
          fill: "white"
        })
      ])
    ])
  ])
], -1)
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "mt-8 flex gap-3 text-base" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_14 = { class: "fixed inset-0 z-10 w-screen overflow-y-auto" }
const _hoisted_15 = { class: "flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0" }
const _hoisted_16 = { class: "text-start" }

import { onBeforeUnmount, onMounted, ref} from "vue";
// Importing a file upload component
import FileUploadWidgetComponent from "../components/FileUploadWidgetComponent.vue";
// Importing UI components from Headless UI
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
// Importing the school store for state management
import { useSchoolStore } from "@/stores/schoolStore";
import { School } from "@/interfaces/school.interface";
import { SchoolStructure } from "@/interfaces/school-structure.interface";
import { useSubjectStore } from "@/stores/subjectStore";
import { Subject } from "@/interfaces/subject.interface";

// Define props that the component accepts

export default /*#__PURE__*/_defineComponent({
  __name: 'BulkLearnersUploadComponent',
  props: {
  uploadType: {
    type: String,
  },
  classId: {
    type: String,
  },
  className: {
    type: String,
  },
  grade: {
    type: Number,
  },
},
  emits: [ 
  "transmitLearnersToUpload",
  "closeUploadModal",
  "resetState",
  "resetModalState"
],
  setup(__props, { emit }) {

const props = __props;



// Reactive references to manage the component's state
const showGenerateEmails = ref(true);
const generateEmails = ref(false);
const showFileUploadModal = ref(false);
const showUploadedLearnersModal = ref(false);
const uploadedLearners = ref<any>([]);
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();

// Emit events to parent components


// Lifecycle hook that runs when the component is mounted
onMounted(() => {
  showGenerateEmails.value = true;
});

onBeforeUnmount(() => {
  emit("resetState");
});

// Function to close the modal
const closeModal = () => {
  emit('resetModalState', false);
};

// Function to handle the reception of uploaded learners from the FileUploadWidgetComponent
const receiveUploadedLearners = (learners: any) => {
  console.log("learners in bulklearnersupload: ", learners);
  showUploadedLearnersModal.value = true;
  uploadedLearners.value = learners;
  emit("transmitLearnersToUpload", uploadedLearners.value);
  emit("closeUploadModal", true);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: showGenerateEmails.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-2xl bg-white text-left shadow-xl transition-all sm:my-8 p-3" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", {
                              class: "absolute top-6 right-4 cursor-pointer",
                              onClick: closeModal
                            }, _hoisted_7),
                            _hoisted_8,
                            _createElementVNode("h1", {
                              class: "mt-5 font-medium text-lg text-[#101828] text-center",
                              innerHTML: 
                      _ctx.$t(
                        'bulk_learner_upload_component.generate_emails_modal.header',
                        {
                          uploadType:
                            props.uploadType == 'grade'
                              ? _ctx.$t(
                                  'bulk_learner_upload_component.generate_emails_modal.grade_label'
                                )
                              : _ctx.$t(
                                  'bulk_learner_upload_component.generate_emails_modal.class_label'
                                ),
                        }
                      )
                    
                            }, null, 8, _hoisted_9),
                            _createElementVNode("p", {
                              class: "font-normal text-sm text-[#475467] mt-4 text-center",
                              innerHTML: 
                      _ctx.$t(
                        'bulk_learner_upload_component.generate_emails_modal.sub_header'
                      )
                    
                            }, null, 8, _hoisted_10),
                            _createElementVNode("p", {
                              class: "font-normal text-sm text-[#475467] mt-4",
                              innerHTML: 
                      _ctx.$t(
                        'bulk_learner_upload_component.generate_emails_modal.email'
                      )
                    
                            }, null, 8, _hoisted_11),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("button", {
                                class: "font-semibold text-[#344054] text-base border-[#D0D5DD] border rounded-lg py-2 px-8",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (
                        (generateEmails.value = false),
                          (showFileUploadModal.value = true),
                          (showGenerateEmails.value = false)
                      ))
                              }, _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.generate_emails_modal.btn_yes"
                        )), 1),
                              _createElementVNode("button", {
                                class: "font-semibold bg-[#155EEF] rounded-lg py-2 px-6 text-white",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (
                        (generateEmails.value = true),
                          (showFileUploadModal.value = true),
                          (showGenerateEmails.value = false)
                      ))
                              }, _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.generate_emails_modal.btn_generate"
                        )), 1)
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: showFileUploadModal.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          class: "relative z-10",
          onClose: closeModal
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_unref(TransitionChild), {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DialogPanel), { class: "relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md sm:p-6" }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_unref(DialogTitle), {
                              as: "h3",
                              class: "text-lg font-semibold leading-6 text-[#101828]"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t(
                        "bulk_learner_upload_component.generate_emails_modal.file_upload_header",
                        {
                          uploadType:
                            props.uploadType == "grade"
                              ? _ctx.$t(
                                  "bulk_learner_upload_component.generate_emails_modal.grade_label"
                                )
                              : _ctx.$t(
                                  "bulk_learner_upload_component.generate_emails_modal.class_label"
                                ),
                        }
                      )), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(FileUploadWidgetComponent, {
                              grade: props.grade,
                              uploadType: props.uploadType,
                              classGroupId: props.classId,
                              shouldGenerateEmail: generateEmails.value,
                              subjects: (_unref(subjectStore).subjects as Subject[]),
                              schoolData: (_unref(schoolStore).currentSchool as School),
                              schoolStructure: (_unref(schoolStore).currentSchoolStructure as SchoolStructure),
                              onCloseUploadModal: _cache[2] || (_cache[2] = ($event: any) => (showFileUploadModal.value = false)),
                              onTransmitLearnersToUpload: receiveUploadedLearners,
                              validate: true
                            }, null, 8, ["grade", "uploadType", "classGroupId", "shouldGenerateEmail", "subjects", "schoolData", "schoolStructure"])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})